















import Vue, { PropType } from 'vue';
import { User } from '@/views/Home/typings';

export default Vue.extend({
	name: 'LoginUserVue',

	props: {
		user: {
			type: Object as PropType<User>,
			default: null,
		},

		loginHandler: {
			type: Function as PropType<() => void>,
			default: null,
		},
	},
});
